import { setTheme } from "theme/default/setTheme";

export const color_ffffff = setTheme(({ theme }) => theme.colors.color_ffffff);
